export default class GameModel {
	id: number;
	name: string;
	title: string;
	// Every price the sheet lists for this game, in sheet order.
	costOptions: number[];
	// The one fixed price, or null when the game has no price or a choice of them.
	costPerPlay: null | number;
	totalPlays: null | number;

	constructor(id: number, name: string, title: string, costPerPlay: any = null, totalPlays: null | number = null) {
		this.id = id;
		this.name = name;
		this.title = title;
		this.costOptions = GameModel.parseCostOptions(costPerPlay);
		this.costPerPlay = this.costOptions.length === 1 ? this.costOptions[0] : null;
		this.totalPlays = totalPlays;
	}

	/**
	 * Sheety returns the Cost Per Play cell as a number, an empty string, or a
	 * comma-separated list of prices. Anything that isn't a positive number is
	 * dropped, so one typo can't take the station down.
	 *
	 * The comma is the separator, so thousands separators are unsupported:
	 * "1,000" reads as a single $1 option, not $1000.
	 */
	static parseCostOptions(raw: any): number[] {
		if (raw === null || raw === undefined) return [];

		return String(raw)
			.split(",")
			.map((part: string) => parseFloat(part.trim().replace(/^\$/, "")))
			.filter((cost: number) => Number.isFinite(cost) && cost > 0);
	}

	static async fetchAll(): Promise<GameModel[]> {
		const endpoint = process.env.VUE_APP_SHEETY_ENDPOINT + "/sideGames";
		const response = await fetch(endpoint, {
			method: "GET",
			cache: "no-store",
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + process.env.VUE_APP_BEARER_TOKEN,
			},
		});
		const data = await response.json();

		if (!!data.errors) return [];

		const games = data.sideGames.map((game: any) => new GameModel(game.id, game.name, game.title, game.costPerPlay, game.totalPlays));

		return games;
	}
}
